var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('div',{staticClass:"s-layout__index_header"},[_c('div',{staticClass:"btn-group",attrs:{"role":"group","aria-label":"Default button group"}},[_c('button',{staticClass:"btn",class:_vm.$route.name.includes('items') && !_vm.$route.name.includes('invoices-index')
            ? 'active'
            : '',attrs:{"type":"button"},on:{"click":function($event){return _vm.$router.push({ name: 'invoices-index' })}}},[_vm._v(" Factures ")])])]),_c('br'),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }